import useCollectedUserData from './useCollectedUserData';

const useEligibleActions = (refetch = false) => {
  const { eligibleActions } = useCollectedUserData(refetch);
  return eligibleActions;
};

export default useEligibleActions;
